import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
import useTelegramPlayerFullscreen from "core/hooks/useTelegramPlayerFullscreen";

const PlayerFullscreenContext = createContext({
  isPlayerFullscreen: false,
  togglePlayerFullscreen: () => {},
  hasTelegramFallback: false,
});

export function usePlayerFullscreen() {
  return useContext(PlayerFullscreenContext);
}

export default function PlayerFullscreenProvider({ children }) {
  const fullscreenState = useTelegramPlayerFullscreen();

  return (
    <PlayerFullscreenContext.Provider value={fullscreenState}>
      {children}
    </PlayerFullscreenContext.Provider>
  );
}

PlayerFullscreenProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
